import { createContext, useContext, useEffect, useState } from 'react';

const DEFAULT_LANG = process.env.REACT_APP_DEFAULT_LANGUAGE || 'en';

const LanguageContext = createContext({ lang: DEFAULT_LANG, setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem('preferred-lang') || DEFAULT_LANG
  );

  // Keep <html lang> in sync so crawlers and screen readers get the right language
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const updateLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem('preferred-lang', newLang);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang: updateLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
